/**
 * Permissions attribuées à chaque rôle système.
 * Référence : document 04 § 8.2 — matrice rôle × module.
 *
 * Ces listes alimentent les lignes `role_permissions` au peuplement : aucune
 * autorisation n'est codée en dur ailleurs dans l'application.
 */
import { PERMISSION_CODES } from './permissions.map.js';
const ALL_PERMISSIONS = PERMISSION_CODES;
/** Raccourci : toutes les actions d'un module (« crm » → crm.read, crm.create…). */
function modulePermissions(module) {
    const prefix = `${module}.`;
    return ALL_PERMISSIONS.filter((code) => code.startsWith(prefix));
}
export const DEFAULT_ROLE_PERMISSIONS = {
    // Administration complète de la plateforme.
    super_admin: ALL_PERMISSIONS,
    // Administration complète d'une société (périmètre tenant).
    admin_societe: ALL_PERMISSIONS,
    commercial: [
        ...modulePermissions('crm'),
        ...modulePermissions('client'),
        ...modulePermissions('prospect'),
        ...modulePermissions('opportunity'),
        ...modulePermissions('activity'),
        ...modulePermissions('task'),
        ...modulePermissions('contact'),
        ...modulePermissions('calendar'),
        ...modulePermissions('quote'),
        ...modulePermissions('order'),
        ...modulePermissions('signature'),
        ...modulePermissions('ged'),
        ...modulePermissions('item'),
        'category.manage',
        'unit.manage',
        'vat_rate.manage',
        'payment_method.manage',
        'payment_term.manage',
        'text_block.manage',
        'supplier.manage',
        'invoice.read',
        'portal.read',
        'report.read',
    ],
    comptable: [
        'crm.read',
        'client.read',
        'prospect.read',
        'opportunity.read',
        'activity.read',
        'task.read',
        'contact.read',
        'calendar.read',
        'item.read',
        'supplier.read',
        'quote.read',
        'order.read',
        'invoice.read',
        'invoice.validate',
        ...modulePermissions('payment'),
        ...modulePermissions('reminder'),
        ...modulePermissions('treasury'),
        ...modulePermissions('banking'),
        ...modulePermissions('e_invoicing'),
        'signature.read',
        'ged.read',
        'portal.read',
        'report.read',
    ],
    collaborateur: [
        ...modulePermissions('crm'),
        ...modulePermissions('calendar'),
        ...modulePermissions('quote'),
        ...modulePermissions('order'),
        ...modulePermissions('ged'),
        'client.read',
        'prospect.read',
        'opportunity.read',
        'activity.read',
        'task.read',
        'contact.read',
        'item.read',
        'item.create',
        'item.update',
        'supplier.read',
        'invoice.read',
        'payment.read',
        'reminder.read',
        'signature.read',
        'report.read',
    ],
    lecture_seule: [
        'crm.read',
        'client.read',
        'prospect.read',
        'opportunity.read',
        'activity.read',
        'task.read',
        'contact.read',
        'calendar.read',
        'item.read',
        'supplier.read',
        'quote.read',
        'order.read',
        'invoice.read',
        'payment.read',
        'reminder.read',
        'treasury.read',
        'banking.read',
        'ged.read',
        'portal.read',
        'signature.read',
        'e_invoicing.read',
        'report.read',
    ],
};
export function defaultPermissionsForRole(role) {
    return DEFAULT_ROLE_PERMISSIONS[role];
}
//# sourceMappingURL=default-roles.js.map